import PrinterErrorsHistory from "@/views/admin/printer/PrinterErrorsHistory";

export default {
  path: "logs/printer-errors",
  name: "logs-printer-errors",
  component: PrinterErrorsHistory,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
